import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { contactKeys } from './queryKeys';
import useQueryRequestParams from '../../../hooks/useQueryRequestParams';
import markUrl from './markUrl';
const useContact = (profileId, enabled = true) => {
    const additional = useQueryRequestParams();
    return useQuery({
        queryFn: () => axios.get(markUrl('contacts/detail/'), {
            ...additional,
            params: { profile_id: profileId }
        }),
        queryKey: contactKeys.detail(profileId),
        enabled
    });
};
export default useContact;
